import { render, staticRenderFns } from "./OviAdministrator.html?vue&type=template&id=ef3200d4&scoped=true&"
import script from "./OviAdministrator.vue?vue&type=script&lang=js&"
export * from "./OviAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./OviAdministrator.scss?vue&type=style&index=0&id=ef3200d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3200d4",
  null
  
)

export default component.exports